import { Select } from 'foundations-components/transitional/components/Select';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import I18n from 'I18n';
import { usePipeline } from 'crm-object-board-core/pipeline';
import { useHasPerPipelineAccess } from '../../hooks/useHasPerPipelineAccess';
import { useHasSinglePipeline } from '../../hooks/useHasSinglePipeline';
export const ALL_PIPELINES_VALUE = 'all';
import { Button } from 'foundations-components/transitional/components/Button';
import { usePerPipelinePql } from '../../hooks/usePerPipelinePql';
import { useUpgradePoint } from 'ui-addon-upgrades/ums/useUpgradePoint';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PipelineSelectPqlButton = ({
  upgradeKey
}) => {
  const {
    openUpgradePage
  } = useUpgradePoint(upgradeKey);
  return /*#__PURE__*/_jsxs(Button, {
    "data-test-id": "crm-board-card-settings-pipeline-select-pql-button",
    use: "unstyled",
    onClick: () => {
      openUpgradePage();
    },
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "crmObjectBoardCard.settings.editor.perPipelinePqlLink"
    }), /*#__PURE__*/_jsx(LockBadge, {})]
  });
};

// Select all-pipelines (free, starter) or selected-pipeline (pro+)
export const PipelineSelect = () => {
  const selectedPipeline = usePipeline();
  const hasSinglePipeline = useHasSinglePipeline();
  const hasPerPipelineAccess = useHasPerPipelineAccess();
  const upgradeKey = usePerPipelinePql();
  if (!selectedPipeline) {
    return null;
  }

  // for cases where we have a single pipeline, we always show the selected pipeline
  if (hasSinglePipeline || hasPerPipelineAccess) {
    return /*#__PURE__*/_jsx(Select, {
      inlineSize: "100%",
      "data-test-id": "crm-board-card-settings-pipeline-select",
      readOnly: true,
      value: selectedPipeline.pipelineId,
      options: [{
        value: selectedPipeline.pipelineId,
        text: selectedPipeline.label
      }]
    });
  }
  return /*#__PURE__*/_jsx(Select, {
    inlineSize: "100%",
    "data-test-id": "crm-board-card-settings-pipeline-select-with-pql-lock",
    readOnly: false,
    value: ALL_PIPELINES_VALUE,
    options: [{
      value: ALL_PIPELINES_VALUE,
      buttonText: /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "crmObjectBoardCard.settings.editor.allPipelines"
        }), ' ', /*#__PURE__*/_jsx(LockBadge, {})]
      }),
      text: I18n.text('crmObjectBoardCard.settings.editor.allPipelines')
    }],
    dropdownFooter: upgradeKey && /*#__PURE__*/_jsx(PipelineSelectPqlButton, {
      upgradeKey: upgradeKey
    })
  });
};